export const defaultRequestTimeout = 8000;
export const maxBackendTimeout = 1000 * 60 * 5; // equal to alb.tf deregistration_delay
export const maxBackendStreamTimeout = 90000;
